import React from 'react';

const CheckMark: React.FC = () => (
  <svg
    fill="none"
    height="8"
    viewBox="0 0 8 8"
    width="8"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M7.49195 0.433889C7.80461 0.705581 7.83783 1.17929 7.56613 1.49195L2.65518 7.14344L0.433889 4.58719C0.162198 4.27453 0.19541 3.80082 0.508071 3.52913C0.820731 3.25744 1.29444 3.29065 1.56613 3.60331L2.65518 4.85658L6.43389 0.508071C6.70558 0.19541 7.17929 0.162198 7.49195 0.433889Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
);

export { CheckMark };
